(function ($) {
  'use strict';

  $(document).on('keydown', '.header-menu-nav .first-level-item', function (e) {
    const $items = $('.header-menu-nav .first-level-item');
    const index = $items.index(this);

    if (e.key === 'ArrowLeft' && index > 0) {
      e.preventDefault();
      $items.eq(index - 1).focus();
    } else if (e.key === 'ArrowRight' && index < $items.length - 1) {
      e.preventDefault();
      $items.eq(index + 1).focus();
    }
  });

  const observer = new MutationObserver(() => {
    const $btn = $('#cgw_action_btn');
    const iframe = document.getElementById('PBarNextFrame');
    if ($btn.length) {
      $btn.attr('aria-label', 'Hidden Action');
    }

    if (iframe) {
      iframe.setAttribute('aria-label', 'Shopify Preview Bar');
    }
    if ($btn.length && iframe) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})(jQuery);